import Vue from "vue";
import Vuex from "vuex";

import * as apiEvents from "@/store/modules/apiEvents.js";
import * as trackData from "@/store/modules/trackData.js";
import * as notification from "@/store/modules/notification.js";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    notification,
    apiEvents,
    trackData,
  },
  state: {},
});
